document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("bdLensModal");
  if (!modal) return;

  const isFrameless = modal.dataset.frameless === "true";

  // -----------------------
  // BD Lens Add-On Variant IDs (Shopify)
  // -----------------------
  const BD_LENS_ADDON_VARIANTS = {
    CLEAR_BASIC:       53239596122439,
    CLEAR_COMFORT:     53239461577031,
    CLEAR_PLUS:        53239464460615,
    CLEAR_PLUS_BLUE:   53239473963335,
    ZEISS_CLEAR_VISION:53239477633351,
    ZEISS_BLUE_PROTECT:53239478780231,
    CLEAR_IMPACT:      53239517610311,
  };

  // Panel (for width toggling)
  const panel = modal.querySelector(".bd-modal__panel");

  // Steps
  const stepGlasses  = document.getElementById("bdStepGlasses");
  const stepImpact   = document.getElementById("bdStepGlassesImpact");
  const stepRx       = document.getElementById("bdStepRx");
  const stepRxUpload = document.getElementById("bdStepRxUpload");

  // Buttons
  const glassesNext  = document.getElementById("bdGlassesNext");
  const impactNext   = document.getElementById("bdImpactNext");
  const rxBack       = document.getElementById("bdRxBack");
  const rxNext       = document.getElementById("bdRxNext");
  const rxUploadBack = document.getElementById("bdRxUploadBack");
  const rxUploadNext = document.getElementById("bdRxUploadNext");

  // File upload
  const rxFile = document.getElementById("bdRxFile");

  // Product form
  const productForm =
    document.querySelector('form[data-type="add-to-cart-form"]') ||
    document.querySelector("product-form form") ||
    document.querySelector('form[action^="/cart/add"]');

  if (!productForm) return;

  const addToCartBtn =
    productForm.querySelector('button[type="submit"], input[type="submit"], button[name="add"]');

  // State
  let selectedLens         = null;
  let selectedPrice        = "0";
  let selectedAddonVariant = null;
  let isAdding             = false;
  let rxMethod             = null; // 'upload' | 'later'

  // -----------------------
  // Helpers
  // -----------------------
  function hideAllSteps() {
    [stepGlasses, stepImpact, stepRx, stepRxUpload]
      .forEach(s => s && (s.style.display = "none"));
    if (panel) panel.classList.remove("bd-modal--wide");
  }

  function openModal() {
    modal.style.display = "block";
    modal.setAttribute("aria-hidden", "false");
    if (rxFile) rxFile.value = "";
    if (isFrameless) showImpact();
    else showGlasses();
  }

  function closeModal() {
    modal.style.display = "none";
    modal.setAttribute("aria-hidden", "true");
  }

  function lockUI(lock) {
    isAdding = !!lock;
    [glassesNext, impactNext, rxNext, rxUploadNext]
      .filter(Boolean)
      .forEach(b => { if (lock) b.disabled = true; });
  }

  function getAddonVariantId(lensKey) {
    const map = {
      basic:       BD_LENS_ADDON_VARIANTS.CLEAR_BASIC,
      comfort:     BD_LENS_ADDON_VARIANTS.CLEAR_COMFORT,
      plus:        BD_LENS_ADDON_VARIANTS.CLEAR_PLUS,
      plus_blue:   BD_LENS_ADDON_VARIANTS.CLEAR_PLUS_BLUE,
      zeiss_clear:   BD_LENS_ADDON_VARIANTS.ZEISS_CLEAR_VISION,
      clear_premium: BD_LENS_ADDON_VARIANTS.ZEISS_CLEAR_VISION, // gleiches Glas, ohne Zeiss-Branding (Epos)
      zeiss_blue:  BD_LENS_ADDON_VARIANTS.ZEISS_BLUE_PROTECT,
      impact:      BD_LENS_ADDON_VARIANTS.CLEAR_IMPACT,
    };
    return map[lensKey] || null;
  }

  // Schritt 1 (Gläser wählen) — Meistgekauft-Paket ist im Markup vorselektiert,
  // damit man ohne Klick direkt auf "Weiter" kann.
  function showGlasses() {
    hideAllSteps();
    if (stepGlasses) stepGlasses.style.display = "block";
    if (panel) panel.classList.add("bd-modal--wide");

    const preselected =
      document.querySelector("#bdGlassesList .bd-compare-card--selected") ||
      document.querySelector('#bdGlassesList .bd-compare-card[data-lens="plus"]');

    document.querySelectorAll("#bdGlassesList .bd-compare-card").forEach(c => {
      c.classList.remove("bd-compare-card--selected");
    });
    if (preselected) preselected.classList.add("bd-compare-card--selected");

    selectedLens         = preselected ? preselected.getAttribute("data-lens") : null;
    selectedPrice         = preselected ? (preselected.getAttribute("data-price") || "0") : "0";
    selectedAddonVariant = preselected ? getAddonVariantId(selectedLens) : null;

    if (glassesNext) glassesNext.disabled = !selectedLens;
    updateGlassesBtn();
  }

  // Zurück von Schritt 2 (Sehstärke übermitteln) — Auswahl bleibt erhalten.
  function showGlassesBack() {
    hideAllSteps();
    if (stepGlasses) stepGlasses.style.display = "block";
    if (panel) panel.classList.add("bd-modal--wide");
  }

  function updateGlassesBtn() {
    if (!glassesNext) return;
    const card = document.querySelector("#bdGlassesList .bd-compare-card.bd-compare-card--selected");
    if (card) {
      const name  = card.getAttribute("data-name") || "";
      const price = card.getAttribute("data-price") || "0";
      const label = price === "0" ? "Inklusive" : "+CHF " + price;
      glassesNext.textContent = name + " (" + label + ") →";
    } else {
      glassesNext.textContent = "Weiter →";
    }
  }

  function showImpact() {
    hideAllSteps();
    if (stepImpact) stepImpact.style.display = "block";
  }

  function showRx() {
    hideAllSteps();
    if (stepRx) stepRx.style.display = "block";
    if (rxNext) rxNext.disabled = true;
    document.querySelectorAll('input[name="bdRxMethod"]').forEach(i => i.checked = false);
    if (rxFile) rxFile.value = "";
  }

  function showRxUpload() {
    hideAllSteps();
    if (stepRxUpload) stepRxUpload.style.display = "block";
    validateRxUpload();
  }

  // -----------------------
  // Validation
  // -----------------------
  function validateRxUpload() {
    const ok = !!(rxFile?.files?.length);
    if (rxUploadNext) rxUploadNext.disabled = !ok;
  }

  // -----------------------
  // Cart helpers
  // -----------------------
  function clearExistingBdProps() {
    productForm.querySelectorAll('input[data-bd-prop="1"]').forEach(el => el.remove());
  }

  function setProp(name, value) {
    const inputName = `properties[${name}]`;
    productForm.querySelectorAll(`input[name="${CSS.escape(inputName)}"]`).forEach(el => el.remove());
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = inputName;
    input.value = value;
    input.setAttribute("data-bd-prop", "1");
    productForm.appendChild(input);
  }

  function setLensProps() {
    if (selectedLens)         setProp("Gläserpaket", selectedLens);
    setProp("Gläserpaket Aufpreis (CHF)", selectedPrice);
    if (selectedAddonVariant) setProp("Lens Add-On Variant ID", String(selectedAddonVariant));
  }

  function addFileToForm(fileInput, propName) {
    if (!fileInput) return;
    if (!productForm.contains(fileInput)) productForm.appendChild(fileInput);
    if (!productForm.getAttribute("enctype")) productForm.setAttribute("enctype", "multipart/form-data");
    fileInput.name = `properties[${propName}]`;
  }

  // -----------------------
  // ADD TO CART (main via /cart/add multipart + add-on via /cart/add.js)
  // -----------------------
  async function addMainAndAddonToCart() {
    if (isAdding) return;
    isAdding = true;
    lockUI(true);

    try {
      const fd = new FormData(productForm);
      if (!fd.get("quantity")) fd.set("quantity", "1");

      const mainVariantId = fd.get("id");
      if (!mainVariantId) throw new Error("Kein Variant ID im Product-Form gefunden.");

      // Eindeutige Paar-ID damit zwei identische Varianten im Warenkorb korrekt zugeordnet werden
      const pairId = Date.now().toString(36) + Math.random().toString(36).substr(2, 4);
      fd.set("properties[_pair]", pairId);

      // 1) MAIN via /cart/add (multipart, supports file upload)
      const resMain = await fetch("/cart/add", {
        method: "POST",
        body: fd,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      if (!resMain.ok) {
        const txt = await resMain.text();
        throw new Error("Main add failed: " + txt);
      }

      // 2) ADD-ON (optional) via JSON
      const addonIdRaw =
        productForm.querySelector('input[name="properties[Lens Add-On Variant ID]"]')?.value || "";
      const addonVariantId = addonIdRaw ? parseInt(addonIdRaw, 10) : null;

      const knownAddonIds = new Set(Object.values(BD_LENS_ADDON_VARIANTS));
      if (addonVariantId && knownAddonIds.has(addonVariantId)) {
        const resAddon = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            id: addonVariantId,
            quantity: 1,
            properties: {
              "_pair": pairId,
              "Add-on für Variant": String(mainVariantId),
              "Add-on für Produkt": document.title || "Brille",
            },
          }),
        });

        if (!resAddon.ok) {
          const txt = await resAddon.text();
          throw new Error("Add-on add failed: " + txt);
        }
      }

      window.location.href = "/cart";
    } catch (err) {
      console.error(err);
      alert("Ups – etwas hat nicht geklappt. Bitte F12 → Konsole öffnen und den Fehler melden.");
      lockUI(false);
      isAdding = false;
    }
  }

  // Letzter Schritt (Sehstärke übermitteln) führt direkt in den Warenkorb —
  // PD wird hier nicht mehr erhoben; falls sie im eingereichten Sehtest fehlt,
  // wird der Kunde nach dem Kauf separat kontaktiert.
  function finalizeOrder() {
    clearExistingBdProps();
    setLensProps();

    if (rxMethod === "upload") {
      setProp("Sehstärke übermittelt", "Sehtest Upload");
      if (rxFile?.files?.length) addFileToForm(rxFile, "Sehtest Upload");
    } else {
      setProp("Sehstärke", "Wird später per E-Mail eingereicht");
    }

    closeModal();
    addMainAndAddonToCart();
  }

  // -----------------------
  // Close modal
  // -----------------------
  modal.addEventListener("click", function (e) {
    if (e.target && e.target.hasAttribute("data-bd-close")) closeModal();
  });

  // Intercept theme add-to-cart button
  if (addToCartBtn && addToCartBtn.dataset.skipLensModal !== "true") {
    if (addToCartBtn.tagName && addToCartBtn.tagName.toLowerCase() === "button") {
      addToCartBtn.type = "button";
    }
    addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
      openModal();
    }, true);
  }

  // -----------------------
  // STEP 1: Glasses
  // -----------------------
  document.querySelectorAll("#bdGlassesList .bd-compare-card").forEach(card => {
    card.addEventListener("click", () => {
      document.querySelectorAll("#bdGlassesList .bd-compare-card").forEach(c => c.classList.remove("bd-compare-card--selected"));
      card.classList.add("bd-compare-card--selected");
      selectedLens = card.getAttribute("data-lens");
      selectedPrice = card.getAttribute("data-price") || "0";
      selectedAddonVariant = getAddonVariantId(selectedLens);
      if (glassesNext) glassesNext.disabled = false;
      updateGlassesBtn();
    });
  });

  if (glassesNext) {
    glassesNext.addEventListener("click", () => {
      if (!selectedLens) return;
      showRx();
    });
  }

  // -----------------------
  // STEP 1 (frameless): Impact
  // -----------------------
  if (impactNext) {
    impactNext.addEventListener("click", () => {
      selectedLens = "impact";
      selectedPrice = "139";
      selectedAddonVariant = BD_LENS_ADDON_VARIANTS.CLEAR_IMPACT;
      showRx();
    });
  }

  // -----------------------
  // STEP 2: Rx Method
  // -----------------------
  if (rxBack) {
    rxBack.addEventListener("click", () => {
      if (isFrameless) showImpact();
      else showGlassesBack();
    });
  }

  document.querySelectorAll('input[name="bdRxMethod"]').forEach(radio => {
    radio.addEventListener("change", () => {
      if (rxNext) rxNext.disabled = false;
    });
  });

  if (rxNext) {
    rxNext.addEventListener("click", () => {
      const method = document.querySelector('input[name="bdRxMethod"]:checked')?.value;
      rxMethod = method;
      if (method === "upload") showRxUpload();
      if (method === "later")  finalizeOrder();
    });
  }

  // -----------------------
  // STEP: Rx Upload (Fortsetzung von Schritt 2, kein eigener Zähl-Schritt)
  // -----------------------
  if (rxUploadBack) rxUploadBack.addEventListener("click", showRx);
  if (rxFile) rxFile.addEventListener("change", validateRxUpload);

  if (rxUploadNext) {
    rxUploadNext.addEventListener("click", () => {
      if (!rxFile?.files?.length) return;
      finalizeOrder();
    });
  }
});
